import { render, staticRenderFns } from "./SkuSpecModal.vue?vue&type=template&id=4beb8e28&scoped=true"
import script from "./SkuSpecModal.vue?vue&type=script&lang=js"
export * from "./SkuSpecModal.vue?vue&type=script&lang=js"
import style0 from "./SkuSpecModal.vue?vue&type=style&index=0&id=4beb8e28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4beb8e28",
  null
  
)

export default component.exports